import { useToast } from '@chakra-ui/react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { deleteSubFamily } from 'services/api/requests/requests';
import { mapErrorToToastProps } from 'utils/forms/mapErrorToToastProps';
export const useDeleteSubFamily = () => {
	const queryClient = useQueryClient();
	const toast = useToast();
	return useMutation(deleteSubFamily, {
		onSuccess: sucess => {
			queryClient.invalidateQueries(['subfamily']);
			queryClient.invalidateQueries(['subfamily-list']);

			queryClient.refetchQueries(['subfamily']);
			queryClient.refetchQueries(['subfamily-list']);

			toast({
				title: 'Deletado com sucesso!',
				description: 'Subfamilia deletada com sucesso.',
				position: 'bottom-left',
				status: 'success',
				duration: 8000,
				isClosable: true,
			});
		},
		onError: (error: any, variables, context) => {
			const toastErrors: Array<any> = mapErrorToToastProps(
				error,
				'Erro ao deletar Subfamília!'
			);
			toastErrors?.forEach(element => toast(element));
		},
	});
};
